import React, { useEffect, useRef, useState } from 'react';
import './OtpVerify.css';
import { useNavigate } from 'react-router-dom';
import { notify } from '../../../util/helpers';
import { useSelector, useDispatch } from 'react-redux';
import { verifyOtpLogic, sendOtpLogic,resetOtpVerifyToken,resetOtpVerifying} from '../../../store/features/app/appSlice';

const OtpVerifyScreen = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(120); // starting from 54 seconds
  const [isWaiting, setIsWaiting] = useState(true); // used to disable inputs/buttons
  const inputs = useRef([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    otpSending,
    otpVerifying,
    tempToken,
    authToken,
    userData,
    otpError,
    verifyOtpError,
    user,
    password,
    username
  } = useSelector((state) => state.app);

  // Keyboard Backspace Navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Backspace') {
        const active = document.activeElement;
        const index = inputs.current.indexOf(active);
        if (index > 0 && otp[index] === '') {
          inputs.current[index - 1].focus();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [otp]);

  // Handle OTP input
  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // Only allow digits
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  // If Error found then all input box will be empty
  const handleError = () => {
    // Clear all input boxes on invalid OTP
    inputs.current.forEach(input => {
      if (input) input.value = '';
    });
    // Optionally focus the first box again
    inputs.current[0]?.focus();
    setOtp(['', '', '', '', '', ''])
  };

  // Submit OTP for verification
  const handleSubmit = () => {
    const code = otp.join('');
    if (code.length !== 6) {
      notify('Please enter a valid 6-digit OTP','info',null);
      return;
    }

    if (!tempToken) {
      notify('Temporary token not found. Please resend OTP.','info',null);
      return;
    }

    dispatch(verifyOtpLogic({ temp_token: tempToken, otp_code: code }));
  };

  useEffect(() => {
      //*Throw the user to post-login screen if user state is not null.
      if (user) {
        notify('OTP verified successfully!','success',null);
        if (user?.role === "INVOICING_ADMIN") {
          navigate("/billing/");
        } else if (user?.role === "CAREGIVER") {
          navigate("/caregiver/");
        } else {
          navigate("/dashboard/");
        }
      }
      if(!tempToken){
        navigate("/login");
      }
    }, [user,tempToken]);
   

  // Show errors
  useEffect(() => {
    if (otpError) {
      notify(`OTP Send Error: ${otpError}`,'info',null);
    }
    if (verifyOtpError) {
      handleError();
      notify(`Verification Error: ${verifyOtpError}`,'info',null);
    }
  }, [otpError, verifyOtpError]);

  // Handle resend OTP
  const handleResend = () => {
    if (!username || !password) {
      dispatch(resetOtpVerifyToken());
      navigate("/login");
      return;
    }
    
    localStorage.setItem('lastTime', '120');
    dispatch(sendOtpLogic({ username, password }));
    notify("Resending OTP...",'info',null);

     // Restart timer
    setTimer(120);
    setIsWaiting(true);
  };

  useEffect(() => {
    let countdown;
  
    if (isWaiting) {
      countdown = setInterval(() => {
        const time = parseInt(localStorage.getItem('lastTime') || '0', 10);
        
        if (time > 0) {
          const newTime = time - 1;
          setTimer(newTime);
          localStorage.setItem('lastTime', newTime.toString());
        } else {
          setIsWaiting(false); // re-enable everything
          clearInterval(countdown);
        }
      }, 1000);
    }
  
    return () => clearInterval(countdown);
  }, [isWaiting,timer]);

  useEffect(()=>{
   let time = localStorage.getItem('lastTime');
   if(time){
    setTimer(time);
   }
   dispatch(resetOtpVerifying());
  },[])
  
  

  return (
    <div className="otp-container">
      <div className="otp-content">
        <h2 className="otp-heading">OTP Verification</h2>
        <p className="otp-subtext">
          We’ve sent a One-Time Password (OTP) to your email address. Please enter
          <span className="heading-subtext"><br/> the code below to continue.</span>
        </p>

        <div className="otp-inputs">
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={digit}
              ref={(el) => (inputs.current[index] = el)}
              onChange={(e) => handleChange(e.target.value, index)}
              className={`otp-box ${digit ? 'has-value' : ''}`}             
              disabled={otpVerifying}
              />
          ))}
        </div>

        <p className="otp-resend">
            Didn’t receive the code?{" "}
            <strong
              onClick={!isWaiting ? handleResend : undefined}
              style={{ cursor: isWaiting ? "not-allowed" : "pointer", opacity: isWaiting ? 0.5 : 1,color:isWaiting?"":"#395E9D",  textDecoration: "underline"
              }}
            >
              {otpSending ? "Resending..." : "Resend"}
            </strong>
          </p>


          <p className="otp-timer">
            Resend OTP in{" "}
            <span className="otp-time">
              {String(Math.floor(timer / 60)).padStart(2, '0')}:{String(timer % 60).padStart(2, '0')}
            </span>
          </p>

        <button
          className="otp-button"
          onClick={handleSubmit}
          disabled={otpVerifying}
          >
          {otpVerifying ? "Verifying..." : "Verify"}{" "}
          <span className="arrow">→</span>
        </button>

        <button className="back-to-login" onClick={()=>{dispatch(resetOtpVerifyToken());navigate('/login');}}>
        <span className="arrow-back">&larr;</span> Back to Login Page
        </button>
      </div>
    </div>
  );
};

export default OtpVerifyScreen;